import Vue from 'vue'
// import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'
import store from './store'
//全局加载就可以了
import '@/icons'
import './plugins/element.js'
import './assets/css/global.css'
// import 'lib-flexible/flexible.js'
import dayjs from 'dayjs'
const imgUrl = 'http://wz.karon-valve.com/guanlong/'
Vue.prototype.$imgUrl = imgUrl
Vue.prototype.$dayjs = dayjs

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js